import In2CLCHomePage from "./In2CLCHomePage";

export default In2CLCHomePage;
